module.exports = __webpack_public_path__ + "static/img/bg1-hover.37b1a799.png";